import { render, staticRenderFns } from "./single-ticket.vue?vue&type=template&id=a111a990&scoped=true"
import script from "./single-ticket.vue?vue&type=script&lang=js"
export * from "./single-ticket.vue?vue&type=script&lang=js"
import style0 from "./single-ticket.vue?vue&type=style&index=0&id=a111a990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a111a990",
  null
  
)

export default component.exports